import React, { useState, useEffect } from "react";
import ArrowBottom from "../img/ArrowBottom.svg";
import Add_round from "../img/Add_round.svg";
import Minus from "../img/Minus.svg";
import Close_round2 from "../img/Close_round2.svg";
import NavigateBackLogo from "../img/NavigateBackLogo.svg";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../../api/axiosInstance";
import CoupenSuccesGif from "../img/CoupenSuccesGif.gif";
import GifCoupon from "../img/GifCoupon.gif";
import editIcon from "../img/Edit_fill.svg";
import deleteIcon from "../img/deleteicon.svg";
import Close_roundClose from "../img/Close_roundClose.svg";
import axios from "axios";
import Header from "./Header";

const RenewLicensePage = () => {
  const [isTopUpOpen, setIsTopUpOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { item_id, item_type, org_mapper_id, project_code } =
    location.state || {};
  const [licenseData, setLicenseData] = useState(null);
  const [calculations, setCalculations] = useState(null);
  const [topUpPlans, setTopUpPlans] = useState([]);
  const [quantities, setQuantities] = useState({});
  const [couponCode, setCouponCode] = useState("");
  const [isApplyingCoupon, setIsApplyingCoupon] = useState(false);
  const [couponApplied, setCouponApplied] = useState(false);
  const [showCouponGif, setShowCouponGif] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [defaultAddress, setDefaultAddress] = useState(null);
  const [addresses, setAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [address, setAddress] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [city, setCity] = useState("");
  const [district, setDistrict] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [gstNo, setGstNo] = useState("");
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isFromKerala, setIsFromKerala] = useState(false);
  const [locations, setLocations] = useState([]);
  const [showPostalModal, setShowPostalModal] = useState(false);
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [isMessageModalOpen, setMessageModalOpen] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [paymentSuccessModalOpen, setPaymentSuccessModalOpen] = useState(false);
  const [isPaymentVerified, setIsPaymentVerified] = useState(false);
  const [paymentDomain, setPaymentDomain] = useState("");
  const [couponModalVisible, setCouponModalVisible] = useState(false);
  const [couponModalMessage, setCouponModalMessage] = useState("");
  const [lastClickedDropdown, setLastClickedDropdown] = useState(null);

  const toggleTopUp = () => {
    if (lastClickedDropdown && !isTopUpOpen) {
      // Prevent immediate reopen after outside click
      setLastClickedDropdown(null);
      return;
    }
    setIsTopUpOpen((prev) => !prev);
    if (!isTopUpOpen) {
      setLastClickedDropdown("topup"); // or any string
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const dropdown = document.querySelector(".topup-dropdown"); // class you set on dropdown
      if (dropdown && !dropdown.contains(event.target)) {
        setIsTopUpOpen(false);
        setLastClickedDropdown("topup");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isTopUpOpen]);

  const fetchTopUpPlans = async (itemId) => {
    try {
      const token = localStorage.getItem("accessToken");
      const response = await api.get(
        `/display/api/v1/list-top-ups-in-my-product/${itemId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.status === "success") {
        setTopUpPlans(response.data.data); // Adjust if your real response has nested structures
      }
    } catch (error) {
      console.error("Error fetching top-up plans:", error);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchLicenseDetails();
  }, []);

  const fetchLicenseDetails = async () => {
    try {
      const token = localStorage.getItem("accessToken");
      const response = await api.post(
        "/display/api/v1/display-renew",
        {
          item_type: item_type || "license",
          org_mapper_id: org_mapper_id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.status === "success") {
        setLicenseData(response.data.data.cart_data);
        setCalculations(response.data.data.calculations);
        // If there are existing topups, initialize their quantities
        if (response.data.data.cart_data?.topup_data) {
          const initialQuantities = {};
          response.data.data.cart_data.topup_data.forEach((topup) => {
            initialQuantities[topup.top_up_id] =
              topup.limits_data?.[0]?.count || 0;
          });
          setQuantities(initialQuantities);
        }
      }
      if (response.data.data.cart_data?.item_id) {
        fetchTopUpPlans(response.data.data.cart_data.item_id); // <== Pass it here
      }
    } catch (error) {
      console.error("Error fetching license details:", error);
    }
  };

  const handleAddToCart = async () => {
    const accessToken = localStorage.getItem("accessToken");

    const selectedTopUps = topUpPlans
      .filter((topUp) => quantities[topUp.top_up_id] > 0)
      .map((topUp) => ({
        top_up_id: topUp.top_up_id,
        quantity: quantities[topUp.top_up_id],
        is_active: true,
      }));

    if (selectedTopUps.length === 0) {
      showModal("Please select at least one top-up to add to cart.");
      return;
    }

    try {
      const response = await api.post(
        "/display/api/v1/update-renew-cart",
        {
          item_type: item_type || "license",
          org_mapper_id: org_mapper_id,
          coupon_id: null,
          coupon_code: null,
          top_up_data: selectedTopUps,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (response.data.status === "success") {
        const cartData = response.data.data.cart_data;
        const cart = Array.isArray(cartData) ? cartData[0] : cartData;

        setLicenseData(cart);
        setCalculations(response.data.data.calculations);
        const updatedQuantities = {};
        cart?.topup_data?.forEach((topup) => {
          updatedQuantities[topup.top_up_id] =
            topup.limits_data?.[0]?.count || 0;
        });
        setQuantities(updatedQuantities);
        setIsTopUpOpen(false);
      } else {
        showModal("Failed to add top-ups: " + response.data.response_code);
      }
    } catch (error) {
      console.error("API error:", error);
      showModal("Something went wrong while adding top-ups.");
    }
  };

  const updateQuantity = (id, delta) => {
    setQuantities((prev) => ({
      ...prev,
      [id]: Math.max(0, (prev[id] || 0) + delta), // Prevents going below 0
    }));
  };

  const showModal = (message) => {
    alert(message); // Replace with your modal or toast if needed
  };

  const showSuccessModal = () => {
    alert("Top-up added to cart successfully.");
  };

  const updateRenewCart = async (
    topUpId,
    quantity,
    isActive = true,
    lineId = null
  ) => {
    try {
      const token = localStorage.getItem("accessToken");
      const response = await api.post(
        "/display/api/v1/update-renew-cart",
        {
          item_type: item_type || "license",
          org_mapper_id: org_mapper_id,
          coupon_id: null,
          coupon_code: null,
          top_up_data: [
            {
              top_up_id: topUpId,
              quantity: quantity,
              is_active: isActive,
            },
          ],
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.status === "success") {
        const cart = response.data.data.cart_data[0];
        setCalculations(response.data.data.calculations);
        setQuantities("");

        if (isActive) {
          // update the full license data from backend
          setLicenseData(cart);
        } else {
          // remove the deactivated top-up locally
          setLicenseData((prev) => ({
            ...prev,
            topup_data: prev.topup_data.filter(
              (item) => item.top_up_id !== topUpId
            ),
          }));
        }
      } else {
        showModal("Failed to update cart: " + response.data.response_code);
      }
    } catch (error) {
      console.error("Error updating cart:", error);
      alert("Something went wrong while updating cart.");
    }
  };

  const applyCoupon = async () => {
    const cartId = licenseData?.id;
    const couponId = licenseData?.coupon_data?.id;
    const code = couponCode.trim();

    if (!cartId || !code) {
      setCouponModalMessage("Please enter a valid coupon code.");
      setCouponModalVisible(true);

      return;
    }

    setIsApplyingCoupon(true);

    try {
      const token = localStorage.getItem("accessToken");

      const response = await api.post(
        "/display/api/v1/apply-coupon-renew",
        {
          cart_id: cartId,
          coupon_id: couponId, // Let backend identify using coupon_code
          coupon_code: code,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const res = response.data;

      if (res.status === "success") {
        setCouponApplied(true);

        setShowCouponGif(true);
        setTimeout(() => setShowCouponGif(false), 2000);

        const couponDetails = Array.isArray(res.data.coupon_data)
          ? res.data.coupon_data
          : [res.data.coupon_data];

        let updatedValidity = licenseData?.validity;
        let updatedPrice = licenseData?.total_price;
        let updatedLimits = licenseData?.limits_data;
        let prevLimits = licenseData?.limits_data; // store full limit info

        let prevValidity = updatedValidity;
        let prevPrice = updatedPrice;

        couponDetails.forEach((detail) => {
          switch (detail.applying_type) {
            case "duration":
              updatedValidity = detail.data?.[0]?.updated || updatedValidity;
              break;
            case "price":
              updatedPrice = detail.data?.[0]?.updated || updatedPrice;
              break;
            case "limit":
              if (Array.isArray(detail.data)) {
                updatedLimits = detail.data.map((l) => ({
                  based_on: l.based_on,
                  count: l.updated,
                  is_unlimited: l.is_unlimited,
                }));
              }
              break;
          }
        });

        // Update licenseData
        setLicenseData((prev) => ({
          ...prev,
          coupon_details_applied: couponDetails,
          is_coupon_have: true,
          validity: updatedValidity,
          total_price: updatedPrice,
          limits_data: updatedLimits,
          prev_validity: prevValidity,
          prev_total_price: prevPrice,
          prev_limits_data: prevLimits,
        }));

        setCalculations(res.data.calculations);

        setCalculations(res.data.calculations); // ✅ Keep this OUTSIDE
      } else {
        setCouponModalMessage("Please enter a valid coupon code.");
        setCouponModalVisible(true);
      }
    } catch (err) {
      console.error(
        "Error applying coupon:",
        err.response?.data || err.message
      );
      showModal("Something went wrong while applying coupon.");
    } finally {
      setIsApplyingCoupon(false);
    }
  };

  const removeCoupon = () => {
    setCouponApplied(false);
    setCouponCode("");

    setLicenseData((prev) => ({
      ...prev,
      validity: prev?.prev_validity || prev.validity,
      total_price: prev?.prev_total_price || prev.total_price,
      limits_data: prev?.prev_limits_data || prev.limits_data,
      prev_validity: null,
      prev_total_price: null,
      prev_limits_data: null,
      coupon_details_applied: null,
    }));
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const toggleAddressModal = () => {
    setIsAddressModalOpen(!isAddressModalOpen);
  };

  const handleSetDefaultAddress = async (id) => {
    try {
      const token = localStorage.getItem("accessToken"); // Get the token from session storage

      if (!token) {
        console.error("No token found");
        return;
      }

      // Send PATCH request to update the address to default
      const response = await api.patch(
        `/display/api/v1/patch-delete-billing-address/${id}`,
        {
          is_default: true,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        // On successful response, update the address state
        const updatedAddresses = addresses.map(
          (address) =>
            address.id === id
              ? { ...address, is_default: true } // Update the clicked address to default
              : { ...address, is_default: false } // Set the rest to non-default
        );
        setAddresses(updatedAddresses);
        fetchAddresses();
      } else {
        console.error("Failed to update address:", response.data);
      }
    } catch (error) {
      console.error("Error updating address:", error);
    }
  };

  const fetchAddresses = async () => {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      alert("Please log in first.");
      return;
    }
    try {
      const response = await api.get("/display/api/v1/list-billing-address", {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        // Add any authorization token if required
      });

      // No need to call response.json() with Axios, the data is already parsed
      const data = response.data;

      if (data.status === "success") {
        setAddresses(data.data);

        // Set the default address if available
        const defaultAddr = data.data.find((address) => address.is_default);
        setDefaultAddress(defaultAddr);
        console.log("default address", defaultAddr);
      } else {
        console.error("Error fetching addresses", data.response_code);
      }
    } catch (error) {
      console.error("Error fetching addresses", error);
    }
  };

  const handleUpdate = (index) => {
    const addressToEdit = addresses[index];
    setSelectedAddress(addressToEdit);
    setAddress(addressToEdit.address_1);
    setPostalCode(addressToEdit.pincode);
    setCity(addressToEdit.city);
    setDistrict(addressToEdit.district);
    setState(addressToEdit.state);
    setCountry(addressToEdit.country);
    setGstNo(addressToEdit.gstNo);
    setIsEditModalOpen(true); // Open Edit Modal
  };

  const toggleDeleteModal = (id = null) => {
    setSelectedAddressId(id);
    setIsDeleteModalOpen(!isDeleteModalOpen);
  };

  useEffect(() => {
    if (isModalOpen) {
      fetchAddresses();
    }
  }, [isModalOpen]);

  const handlePostalCodeChange = async (e) => {
    const enteredPostalCode = e.target.value;
    setPostalCode(enteredPostalCode);

    // Only call API when exactly 6 digits
    if (!enteredPostalCode || enteredPostalCode.length !== 6) {
      setShowPostalModal(false);
      setLocations([]);
      setSelectedLocation(null);
      setIsFromKerala(false);
      return;
    }

    try {
      const res = await axios.get(
        `https://api.postalpincode.in/pincode/${enteredPostalCode}`
      );

      const first = Array.isArray(res.data) ? res.data[0] : null;

      if (first?.Status === "Success" && Array.isArray(first?.PostOffice)) {
        // ✅ Normalize response to match your existing UI structure
        const normalized = first.PostOffice.map((po, idx) => ({
          id: `${enteredPostalCode}-${idx}`,
          postalLocation: po.Name, // used in modal label + city assignment in confirm
          district: po.District,
          state: po.State,
          country: po.Country,
          postalCode: enteredPostalCode,
        }));

        const foundKerala = normalized.some(
          (loc) => (loc.state || "").toLowerCase() === "kerala"
        );

        setIsFromKerala(foundKerala);
        setLocations(normalized);
        setShowPostalModal(true);
      } else {
        // No records / invalid pincode
        setShowPostalModal(false);
        setLocations([]);
        setSelectedLocation(null);
        setIsFromKerala(false);
      }
    } catch (error) {
      console.error("Error fetching postal data:", error);
      setShowPostalModal(false);
      setLocations([]);
      setSelectedLocation(null);
      setIsFromKerala(false);
    }
  };

  const handleSaveAddress = async () => {
    if (
      !address.trim() ||
      !city.trim() ||
      !state.trim() ||
      !postalCode.trim() ||
      !district.trim() ||
      !country.trim()
    ) {
      showModal("Please fill in all required fields before saving.");
      return;
    }
    console.log("Save clicked with data:", {
      address_1: address,
      city,
      state,
      pincode: postalCode,
      latitude: latitude || 0,
      longitude: longitude || 0,
      district,
      country,
      license_number: gstNo || "", // ✅ Correctly pass gstNo as license_number
      is_from_kerala: isFromKerala,
    });

    try {
      const res = await api.post(
        "/display/api/v1/create-billing-address",
        {
          address_1: address,
          city,
          state,
          pincode: postalCode,
          latitude: latitude || 0,
          longitude: longitude || 0,
          district,
          country,
          license_number: gstNo || "", // ✅ This is required by API
          is_from_kerala: isFromKerala,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Billing address created:", res.data);
      fetchAddresses();

      // Clear form inputs
      setAddress("");
      setCity("");
      setCountry("");
      setDistrict("");
      setGstNo("");
      setPostalCode("");
      setState("");

      setIsAddressModalOpen(false); // Close the modal on success
    } catch (err) {
      console.error("Error creating billing address:", err.response || err);
    }
  };

  const toggleEditModal = () => {
    setIsEditModalOpen(!isEditModalOpen);
  };

  const handleEditAddress = async () => {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      alert("Please log in first.");
      return;
    }

    try {
      const updatedAddress = {
        address_1: address,
        pincode: postalCode,
        city,
        district,
        state,
        country,
        gstNo,
      };

      // Make PATCH request to the server
      const response = await api.patch(
        `/display/api/v1/patch-delete-billing-address/${selectedAddress.id}`,
        updatedAddress,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (response.status === 200) {
        // On successful update, update the address list
        const updatedAddresses = addresses.map((addr) =>
          addr.id === selectedAddress.id ? { ...addr, ...updatedAddress } : addr
        );
        setAddresses(updatedAddresses);
        toggleEditModal(); // Close the modal
      } else {
        console.error("Failed to update address");
      }
    } catch (error) {
      console.error("Error updating address:", error);
    }
  };

  const handleDeleteAccount = async () => {
    // Retrieve the access token from session storage
    const accessToken = localStorage.getItem("accessToken");

    // Check if access token exists; if not, prompt the user to log in
    if (!accessToken) {
      alert("Please log in first.");
      return;
    }
    // 🛑 Prevent deleting the default address
    if (selectedAddressId === defaultAddress?.id) {
      setMessage("You cannot delete the default billing address.");
      setMessageType("error");
      setMessageModalOpen(true);
      return;
    }

    try {
      // Make a DELETE request to the backend API to delete the address
      const response = await api.delete(
        `/display/api/v1/patch-delete-billing-address/${selectedAddressId}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`, // Add Authorization header with access token
          },
        }
      );

      // If the response status is 200, it means the delete operation was successful
      if (response.status === 200) {
        fetchAddresses();
        // Filter the addresses list to remove the deleted address
        setAddresses(
          addresses.filter((address) => address.id !== selectedAddressId)
        );
        // Set the success message
        setMessage("Address successfully deleted!");
        setIsDeleteModalOpen(false);
        // Set the message type as success
        setMessageType("success");
        // Open the success modal
        setMessageModalOpen(true);
      } else {
        // If the status is not 200, set the error message
        setMessage("Failed to delete the address. Please try again.");
        // Set the message type as error
        setMessageType("error");
        // Open the error modal
        setMessageModalOpen(true);
      }
    } catch (error) {
      // Handle any errors that occur during the delete request
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        // If the error response contains a message, display it
        setMessage(`Error: ${error.response.data.message}`);
      } else {
        // If no error message is returned, display a generic error message
        setMessage("An error occurred. Please try again.");
      }
      // Set the message type as error
      setMessageType("error");
      // Open the error modal
      setMessageModalOpen(true);
    }
  };

  const handleLocationSelection = (location) => {
    setSelectedLocation(location); // Update selected location with the details
  };

  const handleModalClose = () => {
    setShowPostalModal(false);
  };

  const handleConfirmLocation = () => {
    if (selectedLocation) {
      // If we're editing an address
      if (isEditModalOpen && selectedAddress) {
        setCity(selectedLocation.postalLocation); // Use postal location for city
        setDistrict(selectedLocation.district); // Use selected district
        setState(selectedLocation.state); // Use selected state
        setCountry(selectedLocation.country); // Use selected country
        setPostalCode(selectedLocation.postalCode); // Use postal code

        // Close the postal location modal and open the edit address modal
        setShowPostalModal(false);
        setIsEditModalOpen(true); // Open the edit modal
      } else {
        // If we're adding a new address
        setCity(selectedLocation.postalLocation); // Use postal location for city
        setDistrict(selectedLocation.district); // Use selected district
        setState(selectedLocation.state); // Use selected state
        setCountry(selectedLocation.country); // Use selected country
        setPostalCode(selectedLocation.postalCode); // Use postal code

        // Close the postal location modal and open the add address modal
        setShowPostalModal(false);
        setIsAddressModalOpen(true); // Open the add address modal
      }
    }
  };

  const toggleMessageModal = () => {
    setMessageModalOpen(!isMessageModalOpen);
    setIsDeleteModalOpen(!isDeleteModalOpen);
    setMessage(""); // Reset message when modal is toggled
  };

  const handleProceed = async () => {
    if (!defaultAddress) {
      alert("Please select a default billing address before proceeding.");
      return;
    }
    // Declare at the top of the component

    setIsLoading(true); // Start loading

    const requestBody = {
      address_id: defaultAddress.id, // Use selected default address ID
      coupon_id: couponCode.trim() ? licenseData?.coupon_data?.id : null, // Coupon ID if available
      item_id: licenseData?.item_id, // Item ID
      item_type: item_type, // Can be dynamically set if needed
      coupon_code: couponCode.trim() || null, // Coupon code entered by the user
    };

    try {
      // API call to initiate payment
      const token = localStorage.getItem("accessToken");
      const response = await api.post(
        "/display/api/v1/initiate-renew-payment",
        requestBody,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status === "success") {
        const { razorpay_code, total_amount, razorpay_key, purchase_id } =
          response.data.data;

        if (parseFloat(total_amount) === 0) {
          // ✅ Directly verify if total is 0
          await handlePaymentSuccess(
            {
              razorpay_order_id: razorpay_code,
              razorpay_payment_id: razorpay_key, // Use a placeholder if needed
              // razorpay_signature: "", // Use a placeholder if needed
            },
            purchase_id
          );
        } else {
          // 💳 Proceed with Razorpay
          initRazorpay(razorpay_key, razorpay_code, total_amount, purchase_id);
        }

        // Proceed to Razorpay Integration
        // initRazorpay(razorpay_key, razorpay_code, total_amount, purchase_id);
      } else {
        alert(response.data.message || "Failed to initiate payment.");
      }
    } catch (error) {
      console.error("Error initiating payment:", error);
      alert("Something went wrong while initiating payment.");
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  const initRazorpay = (
    razorpay_key,
    razorpay_code,
    total_amount,
    purchase_id
  ) => {
    const options = {
      key: razorpay_key, // Provided by Razorpay
      amount: total_amount * 100, // Amount is in paise (100 paise = 1 INR)
      currency: "INR", // Currency is INR by default
      name: "MGC",
      description: "Renew License Payment",
      order_id: razorpay_code, // Razorpay order ID received
      handler: function (response) {
        // Payment success handler
        console.log("Payment Success:", response);
        handlePaymentSuccess(response, purchase_id);
      },
      prefill: {
        name: "User Name", // Replace with dynamic user info if available
        email: "user@example.com", // Replace with dynamic email if available
        contact: "+919876543210", // Replace with dynamic contact if available
      },
      theme: {
        color: "#8973EF", // You can customize the color of the Razorpay UI
      },
    };

    // Initialize Razorpay
    const razorpay = new window.Razorpay(options);

    // Open Razorpay Payment Gateway
    razorpay.open();
  };

  // Payment Success Handler
  const handlePaymentSuccess = async (paymentResponse, purchase_id) => {
    console.log("Payment response:", paymentResponse);

    const token = localStorage.getItem("accessToken");

    const payload = {
      razorpay_order_id: paymentResponse.razorpay_order_id,
      razorpay_payment_id: paymentResponse.razorpay_payment_id,
      razorpay_signature: paymentResponse.razorpay_signature,
      purchase_id: purchase_id,
    };

    try {
      const response = await api.post(
        "/display/api/v1/verify-purchase",
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status === "success") {
        console.log("Final confirmation response:", response.data);
        setPaymentDomain(response.data.data.domain);
        setPaymentSuccessModalOpen(true);
        setIsPaymentVerified(true);
      } else {
        alert(response.data.message || "Final payment confirmation failed.");
      }
    } catch (error) {
      console.error("Error confirming payment:", error);
      alert("Something went wrong while confirming payment.");
    }
  };

  return (
    <div className="">
      {/* <div
        className="h-[62px] px-5 w-full bg-[#4C3A68] flex items-center  sticky top-0 z-50 "
        style={{ boxShadow: "0px 4px 5px 0px #8C62E280" }}
      >
        <img
          src={NavigateBackLogo}
          onClick={() => navigate(-1)}
          alt=""
          className="cursor-pointer hover:bg-[#5D4D76] rounded-full p-1"
        />
      </div> */}
      <Header></Header>

      <div className="mx-10 my-5">
        <h1 className="font-semibold text-2xl">Renew Now</h1>

        <div className="flex mt-3 gap-3">
          <div className="w-14 h-14 ">
            <img src={licenseData?.app_icon} alt="" />
          </div>
          <div className="flex flex-col">
            <span className="text-lg">{licenseData?.app_name}</span>
            <span className="text-xs">{licenseData?.company_name}</span>
          </div>
        </div>

        <div className="">
          <div className="">
            <div className="sm:flex hidden mt-3">
              <div className="w-full bg-[#CEC7FF4D] px-4 py-2 flex text-sm font-semibold">
                <span className=" w-[30%]">Plan</span>
                <span className=" w-[20%]">Validity</span>
                <span className=" w-[20%]">Limit</span>
                <span className=" w-[30%]">Price</span>
              </div>
            </div>

            <div
              className=" mt-3 border border-[#D9D9D9] px-4 py-5 rounded-lg"
              style={{ boxShadow: "0px 1px 4px 0px #00000040" }}
            >
              <div className="w-full flex sm:flex-row flex-col sm:items-center">
                <span className=" w-full  sm:w-[30%] flex sm:justify-start justify-between items-center gap-3">
                  <span className="text-sm font-semibold">
                    {licenseData?.item_name}
                  </span>
                  <span
                    onClick={() =>
                      navigate("/upgradedPlan", {
                        state: {
                          item_id,
                          item_type,
                          org_mapper_id,
                          project_code,
                        },
                      })
                    }
                    className="flex justify-center items-center py-1 text-[#8777F3] cursor-pointer text-xs font-semibold border px-3 border-[#8777F3] border-1 rounded-full "
                  >
                    Upgrade Now
                  </span>
                </span>
                <span className="text-sm mb-1 w-[20%]">
                  {licenseData?.prev_validity !== licenseData?.validity ? (
                    <>
                      <div className="flex flex-col">
                        <span className="line-through decoration-red-500  mr-2">
                          {licenseData?.prev_validity}
                        </span>
                        <span className="">{licenseData?.validity}</span>
                      </div>
                    </>
                  ) : (
                    licenseData?.validity
                  )}
                </span>

                <span className=" w-[20%]"></span>
                <span className="text-sm sm:text-lg mb-1">
                  <div className="flex flex-col text-sm">
                    {licenseData?.prev_total_price &&
                      licenseData?.prev_total_price !==
                        licenseData?.total_price && (
                        <span
                          className="text-lg mr-2"
                          style={{
                            position: "relative",
                            color: "#EF4444", // red-500
                            display: "inline-block",
                          }}
                        >
                          ₹{licenseData?.prev_total_price}
                          <span
                            style={{
                              content: '""',
                              position: "absolute",
                              top: "50%",
                              left: 0,
                              right: 0,
                              height: "1px",
                              backgroundColor: "red",
                              transform: "translateY(-50%)",
                            }}
                          />
                        </span>
                      )}
                    <span className="">₹{licenseData?.total_price}</span>
                  </div>
                </span>

                {!licenseData?.topup_data?.length && (
                  <div className="relative sm:ml-auto sm:w-64 w-64">
                    <div
                      className={`flex flex-col cursor-pointer rounded px-3 py-2 transition-all duration-300 ${
                        isTopUpOpen
                          ? "bg-[#FFFFFF] border"
                          : "bg-[#CEC7FF4D] border border-transparent"
                      }`}
                      onClick={toggleTopUp}
                    >
                      <div className="flex justify-between items-center">
                        <span className="text-[#9367D7] text-sm font-semibold">
                          Top Up Plan
                        </span>
                        <img
                          src={ArrowBottom}
                          alt=""
                          className={`transform transition-transform duration-300 ${
                            isTopUpOpen ? "rotate-180" : ""
                          }`}
                        />
                      </div>
                    </div>

                    {isTopUpOpen && (
                      <div className="absolute topup-dropdown top-full w-64 right-0 z-10 mt-2 bg-white rounded-lg shadow-lg border px-3 py-2">
                        {topUpPlans.map((plan) => (
                          <div
                            key={plan.top_up_id}
                            className="w-full bg-white rounded-lg shadow border border-[#9367D7] px-3 py-2 mb-2"
                          >
                            <div className="flex flex-col sm:flex-row justify-between items-center gap-2">
                              <div className="flex flex-col gap-1">
                                <span className="text-xs"> {plan.name}</span>
                                <span className="text-[#ACA7A7] text-xs">
                                  ₹{plan.price} / {plan.top_up_count} qty
                                </span>
                              </div>

                              <div className="flex gap-1 items-center">
                                <img
                                  src={Minus}
                                  alt="Decrease"
                                  onClick={() =>
                                    updateQuantity(plan.top_up_id, -1)
                                  } // 🔽 Decrease
                                  className="cursor-pointer w-[20px]"
                                />
                                <input
                                  type="number"
                                  readOnly
                                  value={quantities[plan.top_up_id] || 0} // 🔢 Show value
                                  className="bg-[#E6E2FF] h-6 w-8 rounded-lg text-center"
                                />
                                <img
                                  src={Add_round}
                                  alt="Increase"
                                  onClick={() =>
                                    updateQuantity(plan.top_up_id, 1)
                                  } // 🔼 Increase
                                  className="cursor-pointer w-[20px]"
                                />
                              </div>
                            </div>
                          </div>
                        ))}

                        <div className="flex w-full justify-between mt-4">
                          <span className="font-semibold text-xs">
                            Top up Total pay
                          </span>
                          <span className="text-sm">
                            ₹
                            {topUpPlans
                              .reduce(
                                (sum, plan) =>
                                  sum +
                                  (quantities[plan.top_up_id] || 0) *
                                    plan.price,
                                0
                              )
                              .toFixed(2)}
                          </span>
                        </div>
                        <div className="flex w-full justify-end mt-2">
                          <button
                            onClick={handleAddToCart}
                            className="font-semibold text-sm text-white px-3 py-2 rounded-lg"
                            style={{
                              background:
                                "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                            }}
                          >
                            Add More
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
              {licenseData?.limits_data?.map((limit, index) => (
                <div className="flex mt-2" key={index}>
                  <span className="text-xs text-[#8C8C8C] w-[30%] ">
                    {limit.limit_name}
                  </span>
                  <span className="text-sm w-[20%]"></span>
                  <span className="text-sm w-[20%]">{limit.count}</span>
                  <span className="text-lg w-[30%]">
                    <div className="relative">
                      {showCouponGif && (
                        <div className="absolute left-1/3">
                          <img
                            src={CoupenSuccesGif}
                            alt="Coupon Applied"
                            className="h-24"
                          />
                        </div>
                      )}
                      {showCouponGif && (
                        <div className="absolute left-2">
                          <img
                            src={GifCoupon}
                            alt="Coupon Applied"
                            className="h-24"
                          />
                        </div>
                      )}
                    </div>
                  </span>
                </div>
              ))}
            </div>

            {licenseData?.topup_data?.length > 0 && (
              <div
                className=" mt-3 border border-[#D9D9D9] rounded-lg px-4 py-5"
                style={{ boxShadow: "0px 1px 4px 0px #00000040" }}
              >
                <div className="w-full flex">
                  <div className=" w-full relative flex  items-center gap-3">
                    <span className="text-sm font-semibold">
                      Additional licenses
                    </span>
                    <div className="relative sm:ml-auto sm:w-64 w-64">
                      <div
                        className={`flex flex-col cursor-pointer rounded px-3 py-2 transition-all duration-300 ${
                          isTopUpOpen
                            ? "bg-[#FFFFFF] border"
                            : "bg-[#CEC7FF4D] border border-transparent"
                        }`}
                        onClick={toggleTopUp}
                      >
                        <div className="flex justify-between items-center">
                          <span className="text-[#9367D7] text-sm font-semibold">
                            Add More
                          </span>
                          <img
                            src={ArrowBottom}
                            alt=""
                            className={`transform transition-transform duration-300 ${
                              isTopUpOpen ? "rotate-180" : ""
                            }`}
                          />
                        </div>
                      </div>

                      {isTopUpOpen && (
                        <div className="absolute topup-dropdown top-full w-64 right-0 z-10 mt-2 bg-white rounded-lg shadow-lg border px-3 py-2">
                          {topUpPlans.map((plan) => (
                            <div
                              key={plan.top_up_id}
                              className="w-full bg-white rounded-lg shadow border border-[#9367D7] px-3 py-2 mb-2"
                            >
                              <div className="flex flex-col sm:flex-row justify-between items-center gap-2">
                                <div className="flex flex-col gap-1">
                                  <span className="text-xs"> {plan.name}</span>
                                  <span className="text-[#ACA7A7] text-xs">
                                    ₹{plan.price} / {plan.top_up_count} qty
                                  </span>
                                </div>

                                <div className="flex gap-1 items-center">
                                  <img
                                    src={Minus}
                                    alt="Decrease"
                                    onClick={() =>
                                      updateQuantity(plan.top_up_id, -1)
                                    } // 🔽 Decrease
                                    className="cursor-pointer w-[20px]"
                                  />
                                  <input
                                    type="number"
                                    readOnly
                                    value={quantities[plan.top_up_id] || 0} // 🔢 Show value
                                    className="bg-[#E6E2FF] h-6 w-8 rounded-lg text-center"
                                  />
                                  <img
                                    src={Add_round}
                                    alt="Increase"
                                    onClick={() =>
                                      updateQuantity(plan.top_up_id, 1)
                                    } // 🔼 Increase
                                    className="cursor-pointer w-[20px]"
                                  />
                                </div>
                              </div>
                            </div>
                          ))}

                          <div className="flex w-full justify-between mt-4">
                            <span className="font-semibold text-xs">
                              Top up Total pay
                            </span>
                            <span className="text-sm">
                              ₹
                              {topUpPlans
                                .reduce(
                                  (sum, plan) =>
                                    sum +
                                    (quantities[plan.top_up_id] || 0) *
                                      plan.price,
                                  0
                                )
                                .toFixed(2)}
                            </span>
                          </div>
                          <div className="flex w-full justify-end mt-2">
                            <button
                              onClick={handleAddToCart}
                              className="font-semibold text-sm text-white px-3 py-2 rounded-lg"
                              style={{
                                background:
                                  "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                              }}
                            >
                              Add More
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {licenseData?.topup_data?.map((topup, idx) => (
                  <div
                    key={topup.id}
                    className="flex mt-2 sm:flex-row flex-col items-start  sm:items-center justify-around"
                  >
                    <span className="text-xs text-[#8C8C8C] w-[30%]">
                      {topup.limits_data[0]?.limit_name || "Additional Limit"}
                    </span>
                    <span className="text-sm  sm:w-[20%]"></span>
                    <span className="text-xs sm:w-[20%]">
                      {topup.limits_data[0]?.count}
                    </span>
                    <span className="text-lg w-full sm:w-[30%] flex justify-between items-center">
                      <span>₹{topup.total_price}</span>
                      <div className="flex w-[73%] justify-between">
                        <div className="flex gap-2 items-center">
                          <img
                            src={Minus}
                            alt=""
                            className="cursor-pointer"
                            onClick={() =>
                              updateRenewCart(
                                topup.top_up_id,
                                Math.max(
                                  1,
                                  (topup.limits_data[0]?.count || 1) - 1
                                )
                              )
                            }
                          />
                          <input
                            type="number"
                            value={topup.limits_data[0]?.count}
                            className="bg-[#E6E2FF] text-xs  h-6 w-8 rounded-lg text-center"
                          />
                          <img
                            src={Add_round}
                            alt=""
                            onClick={() =>
                              updateRenewCart(
                                topup.top_up_id,
                                (topup.limits_data[0]?.count || 1) + 1
                              )
                            }
                            className="cursor-pointer"
                          />
                        </div>
                        <div className="flex gap-3 items-center">
                          <span className="text-xs text-[#8C8C8C]">
                            ₹
                            {(
                              topup.total_price /
                              (topup.limits_data[0]?.count || 1)
                            ).toFixed(2)}
                            /qty
                          </span>
                          <img
                            src={Close_round2}
                            alt=""
                            className="w-4 h-4 cursor-pointer"
                            onClick={() =>
                              updateRenewCart(
                                topup.top_up_id,
                                topup.limits_data[0]?.count || 1,
                                false,
                                topup.id // 🔑 Pass unique cart top-up ID
                              )
                            }
                          />
                        </div>
                      </div>
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>

          {licenseData?.is_coupon_have ? (
            <div
              className="flex justify-between border border-[#D9D9D9] rounded-lg mt-3 px-4 py-5 "
              style={{ boxShadow: "0px 1px 4px 0px #00000040" }}
            >
              <div className="flex flex-col text-xs">
                <span className="font-semibold">
                  {licenseData.coupon_data?.name}
                </span>

                <span className="text-[#8C8C8C]">
                  {licenseData.coupon_data?.description}
                </span>
              </div>

              <div className="relative sm:w-3/12">
                <input
                  type="text"
                  placeholder="Enter your coupon code"
                  className="border rounded px-3 py-2 border-[#9367D7] w-full"
                  value={couponCode}
                  onChange={(e) => setCouponCode(e.target.value)}
                  disabled={couponApplied} // Optional: disable when applied
                />

                {couponApplied ? (
                  <span
                    onClick={removeCoupon}
                    className="absolute right-[4px] top-[4px] h-8 px-3 rounded text-[#9062DC] font-semibold cursor-pointer flex items-center"
                  >
                    Remove
                  </span>
                ) : (
                  <button
                    disabled={isApplyingCoupon}
                    onClick={applyCoupon}
                    className="absolute right-[4px] top-[4px] h-8 px-3 rounded text-white flex items-center font-semibold"
                    style={{
                      background:
                        "linear-gradient(270deg, #9062DC 0%, #8877F3 100%)",
                    }}
                  >
                    {isApplyingCoupon ? "Applying..." : "Apply"}
                  </button>
                )}
              </div>
            </div>
          ) : null}

          <div
            className="mt-3 border border-[#D9D9D9] rounded-lg px-4 py-5 "
            style={{ boxShadow: "0px 1px 4px 0px #00000040" }}
          >
            <span className="font-semibold text-sm ">Price Details</span>
            <div className="w-full flex mt-3 items-center">
              <span className="text-xs text-[#8C8C8C] w-1/2">
                Actual Amount
              </span>
              <span className="text-sm text-gray-600 w-1/2">
                ₹{calculations?.total_price}
              </span>
            </div>
            <div className="w-full flex mt-3 items-center">
              <span className="text-xs text-[#8C8C8C] w-1/2">
                Discount Amount
              </span>
              <span className="text-sm text-gray-600 w-1/2">
                ₹{calculations?.total_offer}
              </span>
            </div>

            <div className="w-full flex mt-3 items-center">
              <span className="text-xs text-[#8C8C8C] w-1/2">
                Tax Amount ({calculations?.tax_percentage}%)
              </span>
              <span className="text-sm text-gray-600 w-1/2">
                ₹{calculations?.tax_value}
              </span>
            </div>
            <div className="w-full flex mt-3 items-center">
              <span className="font-semibold text-sm w-1/2">Total Amount</span>
              <div className="w-1/2 flex justify-between">
                <span className="text-base font-bold w-1/2">
                  ₹{calculations?.grant_total}
                </span>
                <button
                  style={{
                    background:
                      "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                  }}
                  className="text-white rounded h-8 px-1 sm:px-3 text-sm font-semibold flex justify-center items-center"
                  onClick={toggleModal}
                >
                  Check Out
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white w-3/4 md:w-1/2 p-6 rounded-lg">
            <h1 className="mt-4 text-black text-inter text-xl font-semibold">
              Billing Address
            </h1>

            <div className="w-full h-[158px] bg-white rounded-lg border border-[#D9D9D9] flex flex-col mt-4">
              {/* Top Half */}
              <div className="w-full h-1/2 bg-[#F7F2FF] border-b border-gray-300 flex items-center justify-between px-4 rounded-tl-lg rounded-tr-lg">
                <h2 className="text-lg font-inter font-semibold text-gray-800">
                  Default address
                </h2>
                <button
                  className="text-white text-sm font-medium px-4 py-2 rounded-md"
                  style={{
                    background:
                      "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                  }}
                  onClick={toggleAddressModal}
                >
                  Add a new address
                </button>
              </div>

              {/* Bottom Half */}
              <div className="w-full h-1/2 flex flex-col justify-center px-4">
                {defaultAddress ? (
                  <h2 className="text-sm font-semibold text-black text-inter">
                    {defaultAddress.address_1}, {defaultAddress.city},{" "}
                    {defaultAddress.state}, {defaultAddress.pincode},{" "}
                    {defaultAddress.district}, {defaultAddress.country}
                  </h2>
                ) : (
                  <p className="text-sm text-gray-500">
                    No default address available
                  </p>
                )}
              </div>
            </div>

            {/* Address List */}
            <div className="overflow-x-auto mt-6">
              <div className="flex space-x-4">
                {addresses.length > 0 ? (
                  // Sort the addresses so the default address comes first
                  addresses
                    .sort(
                      (a, b) => (b.is_default ? 1 : 0) - (a.is_default ? 1 : 0)
                    ) // Sort addresses with default first
                    .map((address, index) => (
                      <div
                        key={index}
                        className="flex-shrink-0 w-[400px] h-[158px] bg-white border border-[#D9D9D9] rounded-md px-2 flex"
                      >
                        {/* Address Content (on the left side, 90% width) */}
                        <div className="flex-1">
                          <h2 className="text-sm font-semibold text-black text-inter px-2 py-2">
                            {address.address_1}, {address.city}, {address.state}
                            , {address.pincode}, {address.district},{" "}
                            {address.country}
                          </h2>
                        </div>

                        <div className="w-[10%] flex flex-col items-center justify-between gap-2 px-2 py-2">
                          {/* Custom Checkbox */}
                          <div className="relative">
                            <input
                              type="checkbox"
                              checked={address.is_default}
                              onChange={() =>
                                handleSetDefaultAddress(address.id)
                              } // Trigger onChange to set default
                              className="w-5 h-5 cursor-pointer"
                              style={{
                                appearance: "none",
                                borderRadius: "4px",
                                border: "2px solid #9061DB",
                                backgroundColor: address.is_default
                                  ? "#9061DB"
                                  : "transparent", // Conditional background
                              }}
                            />

                            {/* Checkmark (tick) with inline styles */}
                            {address.is_default && (
                              <div
                                style={{
                                  color: "white",
                                  fontSize: "16px",
                                  fontWeight: "bold", // Added bold for better visibility
                                  position: "absolute",
                                  bottom: "4px",
                                  right: "3px", // Position the checkmark inside the checkbox
                                }}
                              >
                                ✓
                              </div>
                            )}
                          </div>

                          {/* Update Icon */}
                          <img
                            src={editIcon} // Replace with the actual path to your image
                            alt="Update"
                            className="w-5 h-5 cursor-pointer" // Fixed size for consistency
                            onClick={() => handleUpdate(index)} // Call your update function here
                          />

                          {/* Delete Icon */}
                          <img
                            src={deleteIcon} // Replace with the actual path to your image
                            alt="Delete"
                            className="w-5 h-5 cursor-pointer" // Fixed size for consistency
                            onClick={() => toggleDeleteModal(address.id)} // Open Delete Modal with selected address ID
                          />
                        </div>
                      </div>
                    ))
                ) : (
                  <p className="text-sm text-gray-500">
                    No addresses available
                  </p>
                )}
              </div>
            </div>

            {/* Button Container for Cancel and Proceed */}
            <div className="flex justify-end gap-2 mt-4">
              {/* Cancel Button */}

              <button
                className="text-white text-sm font-medium px-4 py-2 rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
                style={{
                  background:
                    "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                }}
                onClick={() => {
                  if (defaultAddress) {
                    handleProceed();
                  } else {
                    alert(
                      "Please select a default billing address before proceeding."
                    );
                  }
                }}
                disabled={!defaultAddress || isLoading}
              >
                {isLoading ? "Processing..." : "Proceed"}
              </button>
              <button
                className="text-sm font-semibold px-4 py-2 rounded-md border border-[#9367D7] text-[#9367D7]"
                onClick={toggleModal} // You can handle the cancel functionality here
              >
                Cancel
              </button>

              {/* Proceed Button */}
              {/* <button
                className="text-white text-sm font-medium px-4 py-2 rounded-md"
                style={{
                  background:
                    "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                }}
                onClick={handleProceed}
              >
                Proceed
              </button> */}
            </div>
          </div>
        </div>
      )}

      {isAddressModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
          <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-lg max-h-[90vh] overflow-hidden">
            <div class="flex justify-between mb-4">
              <h2 className="text-xl font-bold text-left">Billing Address</h2>
              <img
                src={Close_roundClose}
                alt=""
                className="cursor-pointer"
                onClick={toggleAddressModal}
              />
            </div>

            {/* Scrollable Content */}
            <div className="overflow-y-auto max-h-[60vh] pr-1">
              <div className="flex flex-col mb-4 text-sm">
                <label htmlFor="address">Address</label>
                <input
                  type="text"
                  id="address"
                  placeholder="Street Address"
                  className="mb-2 p-2 rounded-lg border border-[#9061DB]"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />

                <label htmlFor="postalCode">Postal Code</label>
                <input
                  type="text"
                  id="postalCode"
                  placeholder="Postal Code"
                  className="mb-2 p-2 rounded-lg border border-[#9061DB]"
                  value={postalCode}
                  onChange={(e) => {
                    const enteredPostalCode = e.target.value;
                    if (enteredPostalCode.length === 6) {
                      setPostalCode(enteredPostalCode);
                      handlePostalCodeChange(e);
                    } else {
                      setPostalCode(enteredPostalCode);
                    }
                  }}
                />

                <label htmlFor="city">City</label>
                <input
                  type="text"
                  id="city"
                  placeholder="City"
                  className="mb-2 p-2 rounded-lg border border-[#9061DB]"
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                />

                <label htmlFor="district">District</label>
                <input
                  type="text"
                  id="district"
                  placeholder="District"
                  className="mb-2 p-2 rounded-lg border border-[#9061DB]"
                  value={district}
                  onChange={(e) => setDistrict(e.target.value)}
                />

                <label htmlFor="state">State</label>
                <input
                  type="text"
                  id="state"
                  placeholder="State"
                  className="mb-2 p-2 rounded-lg border border-[#9061DB]"
                  value={state}
                  onChange={(e) => setState(e.target.value)}
                />

                <label htmlFor="country">Country</label>
                <input
                  type="text"
                  id="country"
                  placeholder="Country"
                  className="mb-2 p-2 rounded-lg border border-[#9061DB]"
                  value={country}
                  onChange={(e) => setCountry(e.target.value)}
                />

                <label htmlFor="gstNo">GST No (optional)</label>
                <input
                  type="text"
                  id="gstNo"
                  placeholder="GST Number"
                  className="mb-2 p-2 rounded-lg border border-[#9061DB]"
                  value={gstNo}
                  onChange={(e) => setGstNo(e.target.value)}
                />
              </div>
            </div>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row justify-end gap-4 mt-4">
              <button
                className="text-sm font-medium px-6 py-2 rounded-md w-full sm:w-24 text-white"
                style={{
                  background:
                    "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                }}
                onClick={handleSaveAddress}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      {isEditModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-3/5 max-w-lg overflow-hidden">
            <div class="flex justify-between mb-4">
              <span className="text-xl font-bold text-left ">
                Edit Billing Address
              </span>
              <img
                src={Close_roundClose}
                alt=""
                className="cursor-pointer"
                onClick={toggleEditModal}
              />
            </div>

            <div className="overflow-y-auto max-h-96">
              <div className="flex flex-col mb-4 text-xs">
                {/* Address Form */}
                <label htmlFor="address">Address</label>
                <input
                  type="text"
                  id="address"
                  placeholder="Street Address"
                  className="mb-2 p-2 rounded-lg border border-[#9061DB]"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />

                <label htmlFor="postalCode">Postal Code</label>
                <input
                  type="text"
                  id="postalCode"
                  placeholder="Postal Code"
                  className="mb-2 p-2 border rounded-lg border-[#9061DB]"
                  value={postalCode}
                  // onChange={(e) => setPostalCode(e.target.value)}
                  onChange={(e) => {
                    const enteredPostalCode = e.target.value;

                    // Only call handlePostalCodeChange if the length is exactly 6 digits
                    if (enteredPostalCode.length === 6) {
                      setPostalCode(enteredPostalCode); // Update postal code in the state
                      handlePostalCodeChange(e); // Trigger the postal code change handler
                    } else {
                      setPostalCode(enteredPostalCode); // Update the state even if it's not 6 digits yet
                    }
                  }}
                />

                <label htmlFor="city">City</label>
                <input
                  type="text"
                  id="city"
                  placeholder="City"
                  className="mb-2 p-2 border rounded-lg border-[#9061DB] rounded"
                  value={city} // Fill city dynamically
                  onChange={(e) => setCity(e.target.value)} // Update city
                />

                <label htmlFor="district">District</label>
                <input
                  type="text"
                  id="district"
                  placeholder="District"
                  className="mb-2 p-2 border rounded-lg border-[#9061DB] rounded"
                  value={district} // Fill district dynamically
                  onChange={(e) => setDistrict(e.target.value)} // Update district
                />

                <label htmlFor="state">State</label>
                <input
                  type="text"
                  id="state"
                  placeholder="State"
                  className="mb-2 p-2 border rounded-lg border-[#9061DB] rounded"
                  value={state} // Fill state dynamically
                  onChange={(e) => setState(e.target.value)} // Update state
                />

                <label htmlFor="country">Country</label>
                <input
                  type="text"
                  id="country"
                  placeholder="Country"
                  className="mb-2 p-2 border rounded-lg border-[#9061DB] rounded"
                  value={country} // Fill country dynamically
                  onChange={(e) => setCountry(e.target.value)} // Update country
                />

                <label htmlFor="gstNo">GST No (optional)</label>
                <input
                  type="text"
                  id="gstNo"
                  placeholder="GST Number"
                  className="mb-2 p-2 border rounded-lg border-[#9061DB] rounded"
                  value={gstNo} // Fill GST number dynamically
                  onChange={(e) => setGstNo(e.target.value)} // Update GST number
                />

                {/* Other fields like City, District, State, Country, GST */}
                {/* Repeat for other fields... */}
              </div>
            </div>
            <div className="flex justify-end mt-4">
              <button
                className="text-sm font-medium py-2 text-white py-2 rounded-md px-3"
                style={{
                  background:
                    "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                }}
                onClick={handleEditAddress}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}

      {isDeleteModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
          <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md mx-auto">
            <h2 className="text-xl font-bold text-center mb-4">
              Confirm Deletion
            </h2>
            <p className="text-lg text-center mb-4">
              Do you want to delete this address?
            </p>
            <div className="flex justify-between gap-4">
              <button
                className="text-sm font-medium px-6 py-2 rounded-md w-full sm:w-24"
                style={{
                  background:
                    "linear-gradient(270deg, #E6E2FF 0%, #D4C6FF 100%)",
                }}
                onClick={toggleDeleteModal} // Close the modal
              >
                Cancel
              </button>
              <button
                className="text-sm font-medium px-6 py-2 rounded-md w-full sm:w-24"
                style={{
                  background:
                    "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                }}
                onClick={handleDeleteAccount} // Confirm deletion
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {showPostalModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
          <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-lg max-h-[90vh] overflow-hidden">
            <h2 className="text-xl font-bold font-inter text-left mb-4">
              Select Postal Location
            </h2>

            {/* Postal Location List */}
            <div className="space-y-4 overflow-y-auto max-h-[60vh] pr-1">
              {locations.length > 0 ? (
                locations.map((location) => (
                  <div key={location.id} className="flex items-center">
                    <input
                      type="radio"
                      name="postalLocation"
                      value={location.id}
                      checked={selectedLocation?.id === location.id}
                      onChange={() => handleLocationSelection(location)}
                      className="mr-2"
                    />
                    <label className="text-sm">{location.postalLocation}</label>
                  </div>
                ))
              ) : (
                <p className="text-sm text-gray-500">
                  No Postal Locations available.
                </p>
              )}
            </div>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row justify-between gap-4 mt-6">
              <button
                onClick={handleModalClose}
                className="text-sm font-medium px-6 py-2 rounded-md w-full sm:w-24"
                style={{
                  background:
                    "linear-gradient(270deg, #E6E2FF 0%, #D4C6FF 100%)",
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleConfirmLocation}
                className="text-sm font-medium px-6 py-2 rounded-md w-full sm:w-24 text-white"
                style={{
                  background:
                    "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      {isMessageModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div
            className={`bg-white p-6 rounded-lg shadow-lg w-2/5 ${
              messageType === "success" ? "border-green-500" : "border-red-500"
            }`}
          >
            {/* <h2 className="text-xl font-bold text-center mb-4">
              {messageType === "success" ? "Success" : "Error"}
            </h2> */}
            <p className="text-lg text-center mb-4">{message}</p>
            <div className="flex justify-center">
              <button
                className="text-sm text-white text-inter font-bold px-6 py-2 rounded-md w-24"
                style={{
                  background:
                    "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                }}
                onClick={toggleMessageModal} // Close the modal
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {paymentSuccessModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
          <div className="relative bg-white p-6 rounded-lg shadow-lg w-full max-w-md mx-auto text-center sm:max-w-lg md:max-w-xl sm:px-8 md:px-12">
            {/* Close Icon Button */}
            <button
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 text-xl font-bold"
              onClick={() => {
                setPaymentSuccessModalOpen(false);
                if (isPaymentVerified) {
                  navigate("/MyProducts");
                }
              }}
              aria-label="Close"
            >
              &times; {/* This renders as a clean "×" close icon */}
            </button>

            <h1 className="text-2xl font-bold text-green-600 sm:text-3xl mb-5">
              Payment Successful
            </h1>

            <p className="mb-6 text-sm px-2 sm:px-0 text-left">
              Thank you for your payment! Your transaction was successful. Check
              your email for credentials and details, or click continue to
              login.
            </p>

            <div className="w-full flex justify-center">
              <button
                className="bg-purple-600 text-white px-6 py-2 rounded hover:bg-purple-700 w-full sm:w-auto sm:px-10"
                onClick={() => {
                  window.open(
                    `https://${paymentDomain}`,
                    "_blank",
                    "noopener,noreferrer"
                  );
                  navigate("/MyProducts");
                }}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      )}

      {couponModalVisible && (
        <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex items-center justify-center">
          <div className="bg-white rounded-lg p-6 w-[90%] max-w-md shadow-xl">
            <h2 className="text-lg font-semibold text-center mb-4 text-red-600">
              Invalid Coupon
            </h2>
            <p className="text-sm text-center text-gray-700">
              {couponModalMessage}
            </p>
            <div className="mt-6 flex justify-center">
              <button
                onClick={() => setCouponModalVisible(false)}
                className="bg-gradient-to-r from-[#9061DB] to-[#8777F3] text-white px-6 py-2 rounded-md font-medium hover:opacity-90"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RenewLicensePage;
